const initialState = "";
export const changeAdminEnterpriseReducer = (state = initialState, action) => {
  if (action.type === "CHANGE_ADMIN_ENTERPRISE") return action.payload.adminEnterprise;
  return state;
};
